'use client';

import Image from 'next/image';

import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from '../styles.module.scss';
import type { Component } from './types';

export const ConsumerReviewContent: Component = ({
  title,
  iconSrc,
  iconSize,
  content,
}) => {
  const formatReviewText = (text: string) => {
    const lineCountMap = new Map<string, number>();

    return text.split('\n').map((line) => {
      const count = lineCountMap.get(line) || 0;

      lineCountMap.set(line, count + 1);
      const key = `${line}-${count}`;

      return (
        <p key={key}>
          {line}
          <br />
        </p>
      );
    });
  };

  return (
    <>
      <div className={styles.containerConsumerReviewContent}>
        <Image
          alt="consumer review icon image"
          className={styles.imageThumbnail}
          height={iconSize}
          src={`${joinSgcmMedia(iconSrc)}`}
          width={iconSize} />
        <div className={styles.sectionText}>
          {title}
        </div>
      </div>
      <div className={styles.contentConsumerReview}>
        {formatReviewText(content)}
      </div>
    </>
  );
};
